import { markRaw } from 'vue'

import SkillsPanel from '@/components/skills/SkillsPanel.vue'
import type { SidebarTabExtension } from '@/types/extensionTypes'

export const useSkillsSidebarTab = (): SidebarTabExtension => {
  return {
    id: 'skills',
    icon: 'pi pi-bolt',
    title: 'Skills',
    tooltip: 'Skills',
    label: 'Skills',
    component: markRaw(SkillsPanel),
    type: 'vue'
  }
}
